import { useSettings } from "@/context/SettingsContext";
import { OverlayCard } from "./OverlayCard";
import { CompactItem } from "./ArticleCard";
import { SectionTitle } from "./SectionTitle";

export const CategorySections = ({ categories }) => {
  const { navCategories } = useSettings();
  return (
  <div className="lg:col-span-3 space-y-12">
    {navCategories.map((c) => {
      const list = categories[c.slug] || [];
      if (!list.length) return null;
      const [first, ...rest] = list;
      return (
        <section key={c.slug} data-testid={`home-section-${c.slug}`}>
          <SectionTitle to={`/rubrique/${c.slug}`}>{c.name}</SectionTitle>
          <div className="grid md:grid-cols-2 gap-5">
            <OverlayCard article={first} />
            <div className="space-y-4">{rest.map((a) => <CompactItem key={a.id} article={a} />)}</div>
          </div>
        </section>
      );
    })}
  </div>
  );
};
